import React from "react";
export default function SVGShip1() {
  return (
    <svg
      version="1.1"
      width="468.406px"
      height="468.405px"
      viewBox="0 0 468.406 468.405"
    >
      <g>
        <g fill="#000000">
          <path d="M262.312,195.714c0-4.513-3.655-8.171-8.171-8.171h-27.792V143.18h-62.802v44.362H58.069    c-4.516,0-8.173,3.659-8.173,8.171v78.461H0l24.509,92.596c0,4.524,3.657,8.171,8.173,8.171h403.043    c4.517,0,8.172-3.646,8.172-8.171l24.509-92.596H262.312V195.714z" />
          <rect
            opacity="0.3"
            x="290.464"
            y="195.519"
            width="60.188"
            height="31.4"
          />
          <rect
            opacity="0.3"
            x="361.115"
            y="195.519"
            width="60.191"
            height="31.4"
          />
          <rect
            opacity="0.3"
            x="361.115"
            y="234.77"
            width="60.191"
            height="31.402"
          />
          <rect
            opacity="0.3"
            x="290.464"
            y="234.77"
            width="60.188"
            height="31.402"
          />
          <path
            opacity="0.3"
            d="M226.349,101.87c0-4.646-3.519-8.406-7.851-8.406h-47.101c-4.332,0-7.851,3.767-7.851,8.406v22.995h62.802V101.87z"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}
